import React, { FC } from "react";
import ArrowIcon from "../../../../../prod/images/redesign/arrowRight.svg?react";
import { SectionHeading } from "../SectionHeading/SectionHeading";
import classNames from "classnames";

interface Service {
  title: string;
  description: string;
  link: string;
  hideMegaMenuItemFromDesktop: boolean;
}

export interface ServicesBlockProps {
  blockTitle: string;
  services: Service[];
}

export const ServicesBlock: FC<ServicesBlockProps> = ({
  services,
  blockTitle,
}) => {
  return (
    <div className="pt-12 pb-16 md:py-20 container">
      <SectionHeading colorVariant="primary" title={blockTitle} />

      <div className="flex-col md:flex-row gap-4 grid grid-cols-12 grid-flow-dense">
        {services.map((service, index) => (
          <div
            className={classNames(
              "justify-between md:flex-col bg-secondaryLightGreen rounded-lg px-4 py-4 md:px-6 md:py-5 col-span-12 md:col-span-6 lg:col-span-3",
                service.hideMegaMenuItemFromDesktop ? 'md:hidden flex' : 'flex'
            )}
            key={index}
          >
            <div>
              <h5 className="text-2xl text-primary font-medium">
                {service.title}
              </h5>
              <p className="text-xs text-primary hidden md:block">
                {service.description}
              </p>
            </div>

            <a href={service.link} className="group self-center md:self-start">
              <ArrowIcon className="self-center md:self-start md:mt-12 group-hover:translate-x-2 transition-all ease-out" />
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};
